import "./App.css";
import MainContainer from "./component/content/MainContainer";
import NavBar from "./component/header/NavBar";
import { useEffect, useState, useContext } from "react";
import whiteBgSvg from "./assets/icons/White_bg.svg";
import dardBgSvg from "./assets/icons/dark_bg.svg";
import { net_works } from "./component/content/bridge/components/networkData";
import { useConnectWallet, useSetChain } from "@web3-onboard/react";
import ErrorDisplay from "./component/reusable/ErrorDisplay2";
import SnackBar from "./component/snackbar/SnackBar";
import { AppContext } from "./AppProvider";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem("theme") === "dark"
  );
  const [netWroks, setNetWroks] = useState([...net_works]);

  const [{ wallet }] = useConnectWallet();
  const [{ connectedChain }, setChain] = useSetChain();
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { state } = useContext(AppContext);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDarkMode]);

  const handleCloseError = () => {
    setIsErrorVisible(false);
    setErrorMessage("");
  };
  const handleSwitchNetwork = async () => {
    try {
      const issetchain = await setChain({ chainId: "0x1530" });
      if (issetchain) handleCloseError();
    } catch (e) {
      // console.log(e);
    }
  };

  useEffect(() => {
    let currentNetwork;
    try {
      if (wallet && wallet.chains) {
        const chainId = connectedChain.id;

        switch (chainId) {
          case "0x1":
            currentNetwork = "ethereum";
            //console.log(currentNetwork);
            break;
          case "0x89":
            currentNetwork = "polygon";
            // console.log(currentNetwork);
            break;
          case "0x38":
            currentNetwork = "bsc";
            // console.log(currentNetwork);
            break;
          case "0x1530":
            currentNetwork = "edexa";
            // console.log(currentNetwork);
            break;

          default:
            console.log("Unsupported network");
            break;
        }

        if (
          currentNetwork !== "ethereum" &&
          currentNetwork !== "polygon" &&
          currentNetwork !== "bsc" &&
          currentNetwork !== "edexa"
        ) {
          setIsErrorVisible(true);
          return;
        }

        for (let i = 0; i < netWroks.length; i++) {
          if (netWroks[i].name === currentNetwork) {
            netWroks[i].isSelectedAsFrom = true;
            if (netWroks[i].isSelectedAsTo) {
              netWroks[i].isSelectedAsTo = false;
              netWroks.filter(
                (el) => !el.isSelectedAsFrom
              )[0].isSelectedAsTo = true;
            }
          } else {
            netWroks[i].isSelectedAsFrom = false;
          }
        }

        // setNetWroks([...netWroks]);
      }
    } catch (e) {
      // console.log(e);
    }
  }, [connectedChain, wallet,netWroks]);

  return (
    <div className="  relative min-h-screen  flex flex-col dark:text-dark-text">
      {/* <ButtonSwap /> */}
      <img
        className="absolute -z-10 size-full object-cover transition-all duration-700 ease-in-out  bg-sunny-primary dark:bg-dark-primary"
        src={isDarkMode ? dardBgSvg : whiteBgSvg}
        alt="bg"
      />
      <div className=" p-4">
        <NavBar
          netWroks={netWroks}
          setNetWroks={setNetWroks}
          isDarkMode={isDarkMode}
          setIsDarkMode={setIsDarkMode}
        />
      </div>
      {/* Conditionally render ErrorDisplay */}
      {isErrorVisible && (
        <ErrorDisplay
          message={errorMessage}
          onClose={handleCloseError}
          onSwitchNetwork={handleSwitchNetwork}
        />
      )}
      <div className=" my-8 flex-grow flex justify-center items-center">
        <MainContainer netWroks={netWroks} setNetWroks={setNetWroks} />
      </div>
      {state.sanckBar.type && (
        <SnackBar message={state.sanckBar.message} type={state.sanckBar.type} />
      )}
    </div>
  );
}

export default App;
